<template>
  <tables content='可查询门店拥有的积分、优惠券、礼品信息' placeholder='请输入门店名称/编号进行搜索' type='store' :columns='columns'></tables>
</template>
<script>
import tables from './components/tables'
  import { ref } from "vue";
export default {
  components: { tables },
  setup(props) {
    const columns = ref([
      {
        title: "门店编号",
        dataIndex: "code",
        key: "code",
      },
      {
        title: "门店级别",
        dataIndex: "level_name",
        key: "level_name",
      },
      {
        title: "门店名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "上级门店",
        dataIndex: "parent_name",
        key: "parent_name",
      },
      {
        title: "状态",
        dataIndex: "status",
        key: "status",
        slots: { customRender: "status" }
      },
      {
        title: "持有积分",
        dataIndex: "point",
        key: "point",
        align:'center',
        slots: { customRender: "point" }
      },
      {
        title: "持有品牌优惠券",
        dataIndex: "brand_coupon_num",
        key: "brand_coupon_num",
      },
      {
        title: "持有门店优惠券",
        dataIndex: "store_coupon_num",
        key: "store_coupon_num",
      },
      {
        title: "持有礼品",
        dataIndex: "gift_num",
        key: "gift_num",
      },
      {
        title: "操作",
        dataIndex: "action",
        key: "action",
        fixed: "right",
        width:220,
        slots: { customRender: "action" }
      }
    ]);
    return{
      columns
    }
  }
  
}
</script>